import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { Address } from 'viem'
import { EWithdrawCollateralDialogContentContainer } from './EWithdrawCollateralDialogContentContainer'

export interface EWithdrawCollateralDialogProps extends CommonDialogProps {
  collateralVault: Address
  collateralAsset: Address
  collateralSymbol: string
  collateralDecimals: number
  collateralLogoURI?: string
  collateralPriceUSD: number
  currentCollateralFormatted: number
  currentDebtUSD: number
  currentLTV: number
  maxLTV: number
  liquidationLTV: number
  accountTotalCollateralUSD?: number
  subAccountId?: number
}

function EWithdrawCollateralDialog({
  open,
  setOpen,
  collateralVault,
  collateralAsset,
  collateralSymbol,
  collateralDecimals,
  collateralLogoURI,
  collateralPriceUSD,
  currentCollateralFormatted,
  currentDebtUSD,
  currentLTV,
  maxLTV,
  liquidationLTV,
  accountTotalCollateralUSD,
  subAccountId,
}: EWithdrawCollateralDialogProps) {
  const isWrongNetwork = useWrongNetwork()
  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <EWithdrawCollateralDialogContentContainer
          closeDialog={() => setOpen(false)}
          collateralVault={collateralVault}
          collateralAsset={collateralAsset}
          collateralSymbol={collateralSymbol}
          collateralDecimals={collateralDecimals}
          collateralLogoURI={collateralLogoURI}
          collateralPriceUSD={collateralPriceUSD}
          currentCollateralFormatted={currentCollateralFormatted}
          currentDebtUSD={currentDebtUSD}
          currentLTV={currentLTV}
          maxLTV={maxLTV}
          liquidationLTV={liquidationLTV}
          accountTotalCollateralUSD={accountTotalCollateralUSD}
          subAccountId={subAccountId}
        />
      </DialogContent>
    </Dialog>
  )
}

export const eWithdrawCollateralDialogConfig: DialogConfig<EWithdrawCollateralDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: EWithdrawCollateralDialog,
}
